'use strict';

var app = require('mag-app'),
    storageKey = 'applications-storage',
    storageData;

function Storage ( uid ) {
    // stalker storage
    this.store = {};

    Object.defineProperty(this, 'prefix', {
        get: function () {
            return uid + '.storage';
        }
    });
    console.log('uid ' + this.prefix);
    console.log('storage' + JSON.stringify(storageData));

    this.originJSON = storageData[this.prefix];

    if ( this.originJSON ) {
        try {
            this.store = JSON.parse(this.originJSON);
        } catch ( error ) {
            console.log(error);
            this.originJSON = '';
        }
    }
}

Storage.init = function ( data ) {
    storageData = data;
};


Storage.prototype.getItem = function ( key ) {
    return this.store[key];
};


Storage.prototype.setItem = function ( key, data ) {
    var serializedData;

    try {
        console.log(JSON.stringify(data));
    } catch ( error ) {
        console.log(error);

        return;
    }

    this.store[key] = data;

    serializedData = JSON.stringify(this.store);

    if ( serializedData !== this.originJSON ) {
        storageData[this.prefix] = this.originJSON = serializedData;
    }

    console.log('SAVE ' + JSON.stringify(window.storage));
    app.stalker.request('storage/', {
        method: 'POST',
        async: true,
        body: JSON.stringify({key: storageKey, value: JSON.stringify(storageData)})
    });
};

module.exports = Storage;
